import { REVISION } from 'three'

export const version = parseInt(REVISION.replace(/\D+/g, ''))
